<template>
    <div>
        <TopBar :hasLogo="true" :hasLangSwitcher="true" data-cy="component_privilege_topbar"></TopBar>
        <div class="page" :class="pageClass" data-cy="container_privilege_page">
            <div class="py-4 text-center text-dark-1 text-sm" v-html="lbl.privilage.welcome" data-cy="text_privilege_welcome">
            </div>
            <div class="text-center" data-cy="container_privilege_history_button">
                <button type="button"
                    class="text-xs h-7 px-2 bg-gold text-dark-3 outline-none appearance-none shadow rounded-5px"
                    @click="goHistory()" data-cy="btn_privilege_go_history">{{ lbl.history.default }}</button>
            </div>

            <div class="p-4 mt-4 pb-0" data-cy="container_privilege_campaign_list_wrapper">
                <CampaignList ref="campaign-list" :modalController="modalController"
                    @onError="onLoadCampaignError($event)" @onLoadingChange="onLoadingChange($event)"
                    data-cy="component_privilege_campaign_list"></CampaignList>
            </div>
        </div>
    </div>

    <div class="flyout-soze" data-cy="container_privilege_flyout">
        <ModalMaster :controller="modalController" data-cy="component_privilege_modal_master"></ModalMaster>
    </div>
</template>
<script>
import TopBar from "@/components/Layout/TopBar/TopBar.vue";
import CampaignList from "@/module/List/component/CampaignList/CampaignList.vue";
import ModalMaster from "@/components/Modal/ModalMaster.vue";

// mixin
import LocaleMixin from "@/mixin/LocaleMixin";
import ModalMixin from "@/mixin/ModalMixin";
import ErrorApiMixin from "@/mixin/ErrorApiMixin";
// config
import ConfigManager from "@/config/ConfigManager";
// service
import { CampaignListFilterConfigBuilder, CampaignListConfigBuilder } from "@/core/Campaign/model/CampaignConfigModel";
// composable
import { useCampaignListHostComposable } from "@/composables/CampaignListComposable"
import usePageClass from "@/composables/PageClassComposable";

export default {
    name: "Privilege",
    components: {
        TopBar,
        CampaignList,
        ModalMaster
    },
    mixins: [LocaleMixin, ErrorApiMixin, ModalMixin],
    setup: function () {
        const filter = new CampaignListFilterConfigBuilder()
        const config = new CampaignListConfigBuilder()

        config.setConfigList(ConfigManager.getCampaignSmsConfig())

        const { states } = useCampaignListHostComposable(config, filter)
        const { pageClass, pageBg } = usePageClass()

        return {
            states,
            pageClass,
            pageBg
        }
    },
    mounted: function () {
        /**@type {import("@/helper/TrackingHelper").TrackingService} */
        const trackingService = this.tracking

        trackingService.screenName("my_campaignlist")
    },
    methods: {
        onLoadCampaignError: function (err) {
            this.errorApi(err)
        },
        onLoadingChange: function () {
            // if (val) {
            //     this.modalController.loadingModal.show()
            // } else {
            //     this.modalController.loadingModal.hide()
            // }
        },
        goHistory: function () {
            this.$router.push({
                name: "history"
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.page {
    &::before {
        content: '';
        background-image: v-bind('pageBg');
        z-index: -1;
        max-width: 600px;
        @apply fixed top-0 left-1/2 h-screen w-full bg-no-repeat bg-cover transform -translate-x-1/2;
    }
}
</style>
